import React from "react";

import { useForm } from "react-hook-form";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";

import { backendURL } from "../../utils/backed-url";
import { useAuth } from "../../context/Auth/auth-context";
import useUserRoleStore from "../../store/user-role";
import { homeForRole } from "../../utils/routes";
import FloatingLabelInput from "../../components/FloatingLabelInput/FloatingLabelInput";

const Login = () => {
  const { setLoggedIn } = useAuth();
  const { setRole } = useUserRoleStore();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");
  console.log(email);
  console.log(searchParams);
  console.log(searchParams.get("email"));
  console.log("we got here");

  const {
    handleSubmit,
    formState: { errors },
    setError,
    register,
  } = useForm({
    defaultValues: {
      email: email || "",
      password: "",
    },
  });

  const onSubmit = (data) => {
    axios
      .post(`${backendURL}/users/api/login`, {
        email: data.email,
        password: data.password,
      })
      .then(({ data }) => {
        localStorage.setItem("token", data.access);
        localStorage.setItem("refresh_token", data.refresh);
        localStorage.setItem("role", data.role);
        setLoggedIn(true);
        setRole(data.role);
        navigate(homeForRole(data.role));
      })
      .catch((e) => {
        if (e?.response?.status === 401) {
          setError("password", {
            type: "manual",
            message: "Invalid credentials, please check your password",
          });
        } else {
          setError("password", {
            type: "manual",
            message: "Something went wrong !!",
          });
        }
      });
  };

  return (
    <div className="signup-container">
      <div className="signup-card">
        <div className="signup__logo-wrapper">
          <img
            className="signup__logo"
            src={"/images/zonkelogo.jpg"}
            alt="logo"
          />
        </div>
        <div className="signup__title">Login to Zonke Energy</div>
        <div className="signup__subtitle">Access your dashboard</div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form-group">
            <FloatingLabelInput
              type={"email"}
              className={""}
              disabled={false}
              name={"email"}
              register={register}
              rules={{ required: "The email field is required." }}
              placeholder={"Email"}
              errors={errors}
            />
          </div>

          <div className="form-group">
            <FloatingLabelInput
              type={"password"}
              className={""}
              disabled={false}
              name={"password"}
              register={register}
              rules={{ required: "The password field is required." }}
              placeholder={"Password"}
              errors={errors}
            />
          </div>

          <button type="submit">Login</button>
        </form>
      </div>
    </div>
  );
};

export default Login;
